import React, { memo } from 'react';
import { StyleSheet, View } from 'react-native';
import { PortalProvider } from '@gorhom/portal';
import { theme } from '@sweetgreen/garnish';

import { useResetDietaryRestrictionsOnLogout } from '@order/components';
import { useCustomerTelemetry } from '@order/Customer';
import {
  useAccessibilityTracking,
  useAppTrackingTransparency,
  useFetchUserCart,
  useNetworkSubscription,
  usePushNotifications,
  useRegisterUrqlErrorTracker,
  useSweetpassPlusPlans,
  useSweetpassTier,
} from '@order/hooks';
import { useTrackLastInteractedStore } from '@order/LastInteractedStore';
import { useResetPlacedOrdersCounterOnLogout } from '@order/PlacedOrdersCounter';

import { useFacebookPixel } from './integrations/facebook-pixel';
import { useKustomerToken } from './integrations/kustomer/hooks';
import { AppNavigation } from './navigation/AppNavigation';

// ────────────────────────────────────────────────────────────────────────────────

export const AppContent = memo(() => {
  useCustomerTelemetry();
  useFetchUserCart();
  useNetworkSubscription();
  usePushNotifications();
  useFacebookPixel();
  useAppTrackingTransparency();
  useTrackLastInteractedStore();
  useAccessibilityTracking();
  useSweetpassTier('cache-and-network');
  useSweetpassPlusPlans('cache-and-network');
  useKustomerToken('cache-and-network');
  useRegisterUrqlErrorTracker();

  useResetDietaryRestrictionsOnLogout();
  useResetPlacedOrdersCounterOnLogout();

  // ─────────────────────────────────────────────────────────────────────

  return (
    <View style={styles.appContainer}>
      <PortalProvider>
        <AppNavigation />
      </PortalProvider>
    </View>
  );
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  appContainer: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: theme.colors.OATMEAL,
  },
});
